import { memo } from 'react'

import { BaseLink } from './BaseLink'
import { IGeneralProps } from './types'

type INativeLinkProps = {
  href: string
  rel?: string
} & IGeneralProps

export const LinkNative = memo(function LinkNative({ href, children, ...props }: INativeLinkProps) {
  return (
    <BaseLink {...props} childrenContent={children}>
      {({ content, ...renderProps }) => (
        <a {...renderProps} href={href}>
          {content}
        </a>
      )}
    </BaseLink>
  )
})
